import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { getWithoutTime } from '../../../helpers/date-helper';

@Component({
  selector: 'app-deadline-change-modal',
  templateUrl: './deadline-change-modal.component.html',
  styleUrls: ['./deadline-change-modal.component.scss'],
})
export class DeadlineChangeModalComponent implements OnInit {
  minDate: Date;
  date: Date;
  isSaveClicked = false;
  constructor(public modalRef: BsModalRef) {}

  ngOnInit() {
    this.date = this.minDate;
  }

  isDateInvalid() {
    return getWithoutTime(this.date) < getWithoutTime(this.minDate);
  }
  onSaveClicked() {
    if (this.isDateInvalid()) return;
    this.isSaveClicked = true;
    this.modalRef.hide();
  }
}
